/*
 * @Author: changcheng
 * @LastEditTime: 2023-04-19 16:15:08
 */
import React, { FC, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Breadcrumb, Space } from "antd";
import { useQuery } from "../../common/utils";
import "./index.less";
import axios from "axios";
const NewsDetail: FC<any> = ({ history, storeData }) => {
  const query = useQuery();
  const id = query.get("id");
  const [information, setInformation] = useState<any>({});
  const getInformation = async () => {
    const { code, data, msg }: any = await axios.post(
      `/main/admin/ce/information/${id}`
    );
    setInformation(data.data);
  };
  useEffect(() => {
    getInformation();
  }, [id]);
  return (
    <div>
      <div className="information-nav">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/index/home">首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>资讯详情</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <div className={"news-detail"}>
        <div className={"title-box"}>
          <span className={"title"}>{information.title}</span>
        </div>
        <Space className={"time"}>
          <span>消息来源：{information.source}</span>
          <span> 时间：{information.createTime}</span>
        </Space>
        <div
          style={{
            border: "1px solid rgba(0, 0, 0, 0.06)",
            marginBottom: "15px",
          }}
        ></div>
        <div style={{ textAlign: "center" }}>
          {information.ImageAllPathUrl && (
            <img
              style={{ width: "330px", height: "220px" }}
              src={information.ImageAllPathUrl}
              alt=""
            />
          )}
        </div>
        <div
          className={"desc"}
          dangerouslySetInnerHTML={{ __html: information.content }}
        />
      </div>
    </div>
  );
};

export default connect((state) => state)(NewsDetail);
